"use strict";

var novicell = novicell || {};
var dgv = dgv || {};

//Newsletter styling of city selection
dgv.newsletterSelect = dgv.newsletterSelect || function () {

    function init() {
        //Check if newsletter select exists
        var allSelect = document.querySelectorAll('.mc4wp-form select');

        if (allSelect.length > 0) {
            createVisualAppealingSelect(allSelect);
        }

    }


    function createVisualAppealingSelect(allSelect){
        //For each select field
        for (var n = 0; n < allSelect.length; n++){
            var select = allSelect[n];

            select.style.height = '0';
            select.style.float = 'left';

            //Create wrapper
            var wrapper = document.createElement('div');
            wrapper.classList.add('select-outer-wrapper');

            //Set selection
            var headingContainer = document.createElement('div');
            var headingContainerClass = 'select-heading-container';
            headingContainer.classList.add(headingContainerClass);
            var heading = select.options[0].innerText;
            headingContainer.innerText = heading;

            //On header click open dropdown
            headingContainer.addEventListener('click', function(){
                if(wrapper.classList.contains('active')){
                    wrapper.classList.remove('active');
                } else{
                    wrapper.classList.add('active');
                }
            });
            //And remove again
            document.addEventListener('click', function(e){
                if (e.target.classList.contains(headingContainerClass)){
                    return;
                }
                wrapper.classList.remove('active');
            });

            wrapper.appendChild(headingContainer);

            insertAfter(wrapper, select);

            var optionWrapper = document.createElement('div');
            optionWrapper.classList.add('option-wrapper');

            //Get all options from select field
            for (var i = 0; i < select.options.length; i++){
                //The first instance is the heading
                if (i == 0) {
                    continue;
                }

                var option = select.options[i];

                //Create option element
                var singleOption = document.createElement('div');
                singleOption.setAttribute('data-value', option.value);
                singleOption.innerText = option.innerText;
                singleOption.classList.add('single-option');

                //When clicking our beautiful select, also select it in the original select element
                singleOption.addEventListener('click', function(){
                    var val = this.getAttribute('data-value');
                    select.value = val;

                    headingContainer.innerText = this.innerText;
                });
                optionWrapper.appendChild(singleOption);
            }

            //Put element into html
            wrapper.appendChild(optionWrapper);
        }
    }

    function insertAfter(newNode, referenceNode) {
        referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    }

    return {
        init: init
    };

}();
